export const passwordForCreateRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/ ])[A-Za-z\d-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]{1,}$/;

export const passwordForCreateRegexString = `/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-#!$@£%^&*()_+|~=\`{}\\[\\]:";'<>?,.\\/ ])[A-Za-z\\d-#!$@£%^&*()_+|~=\`{}\\[\\]:";'<>?,.\\/ ]{1,}$/`;

export const passwordForEditRegex =
  /(^$)|(^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/ ])[A-Za-z\d-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]{8,}$)/;

export const passwordForEditRegexString = `/(^$)|(^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-#!$@£%^&*()_+|~=\`{}\\[\\]:";'<>?,.\\/ ])[A-Za-z\\d-#!$@£%^&*()_+|~=\`{}\\[\\]:";'<>?,.\\/ ]{8,}$)/`;
